// src/app/core/http/mp.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { env } from '../../../environments/environment';
import { catchError, finalize, throwError } from 'rxjs';
import { LoaderService } from '../services/loader/loader.service';
import { AuthServiceService } from '../services/auth-service/auth-service.service';

const isAbsolute = (u: string) => /^https?:\/\//i.test(u);

export const mpInterceptor: HttpInterceptorFn = (req, next) => {
  const oauth = inject(OAuthService);
  const auth = inject(AuthServiceService);
  const loader = inject(LoaderService);
  const token = oauth.getAccessToken();

  const pub  = env.api.baseUrlPublic;
  const prot = env.api.baseUrlProtected;

  let url = req.url;


  if (!isAbsolute(url)) {
    if (url.startsWith('public/')) url = pub + url.slice('public/'.length);
    else if (url.startsWith('mp/')) url = prot + url.slice('mp/'.length);
  }

  const isProtected = url.startsWith(prot);
  const isPublicRegister = url.startsWith(`${pub}/register`);
  let cloned = req.clone({ url });

  if ((isProtected || isPublicRegister) && token) {
    cloned = cloned.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }

  let shown = false;
  const t = setTimeout(() => {
    shown = true;
    loader.show();
  }, 600);

  return next(cloned).pipe(
    catchError((error) => {
      if (error.status === 401 && isProtected && token) {
        auth.relogin();
      }
      return throwError(() => error);
    }),
    finalize(() => {
      clearTimeout(t);
      if (shown) loader.hide();
    })
  );
};
